






























import Vue from "vue";
import Component from "vue-class-component";
import Api from '../../base/api.typings';
import pesquisaService from '../pesquisa/pesquisa-service';
import { debounce } from '../../utils/utils';
import routerService from '../../base/router-service';
import empresaAtualService from "../empresa-atual/empresa-atual-service";

@Component
export default class BarraPesquisa extends Vue {
    resultado: Api.App.Server.Pesquisa.Pesquisar.ResultadoDto = null;

    resultadoItens = [];

    loading = false;

    pesquisa = '';

    executarPesquisa: Function = debounce(() => {
        this.pesquisar();
    }, 500);

    exibirDocumento($event, documentoId: string, documentoTitulo: string) {
        (this.$refs.documentoVisualizar as any).exibirDocumento(event, documentoId, documentoTitulo);
    }

    onComboboxOpenEvent(value: boolean) {
        this.$emit('onComboboxOpen', value)
    }

    comboboxChange(event) {
        if (!event)
            return;

        if (event.abrirTelaPesquisaResultado) {
            routerService.goTo('pesquisa-resultado', { pesquisa: this.pesquisa });
            return;
        }

        if (event.titulo && event.tipoResultado) {
            if (event.tipoResultado == Api.Common.Domain.ResultadoTipoPesquisaEnum.Chamado) {
                routerService.goTo('chamado-detalhar', { chamadoId: event.chamadoId });
            } else {
                this.exibirDocumento(event, event.arquivoId, event.titulo);
            }
        }

        this.onComboboxOpenEvent(false);
    }

    comboboxInputChange(event) {
        let pesquisa = event.srcElement.value;

        this.pesquisa = pesquisa;

        this.executarPesquisa();
    }

    async pesquisar() {
        if (this.pesquisa.length < 3)
            return;

        this.loading = true;

        this.resultado = await pesquisaService.pesquisar({
            paginaAtual: 1,
            paginaTamanho: 4,
            pesquisa: this.pesquisa,
            empresaId: this.empresaId,
        });

        this.resultadoItens = this.resultado.dto;

        if (this.resultado.dto.length > 1)
            this.resultadoItens.push({ titulo: `Ver mais ${this.resultado.quantidadeTotalItens} resultados`, chamadoId: -1, abrirTelaPesquisaResultado: true });
        else if (this.resultado.dto.length == 0)
            this.resultadoItens.unshift({ header: `Nenhum resultado encontrado` });

        this.loading = false;
    }

    empresaId: string = null;

    async created() {
        this.empresaId = await empresaAtualService.obterEmpresaAtualId();
    }
}
